import loopback from './loopback'

// O limite de minutos de cada plano vem das features de ligação do billing:
//   - minutos-ligacoes-90 / -300  → threshold (90 / 300) — vem em item.quotas
//   - nao-realiza-ligacoes        → 0 (gerencial, não liga) — entitlement, só em features
//   - minutos-ligacoes-ilimitado  → null (ilimitado)        — entitlement, só em features
const CALL_MINUTES_FEATURE_PREFIX = 'minutos-ligacoes-'
const NO_CALLS_FEATURE_NAME = 'nao-realiza-ligacoes'
const UNLIMITED_CALLS_FEATURE_NAME = 'minutos-ligacoes-ilimitado'
const ACTIVE_STATUS = 'ACTIVE'

function getVoiceThreshold (item) {
  // Numéricos (90 / 300): o threshold vem da quota de ligação do plano.
  const quotas = Array.isArray(item.quotas) ? item.quotas : []
  const callQuota = quotas.find(q => typeof q.featureName === 'string' && q.featureName.startsWith(CALL_MINUTES_FEATURE_PREFIX))
  if (callQuota && callQuota.threshold !== undefined && callQuota.threshold !== null) return callQuota.threshold

  // Gerencial / unlimited: os entitlements não têm threshold (não entram em quotas),
  // então são identificados pelas features do item.
  const features = Array.isArray(item.features) ? item.features : []
  if (features.some(f => f && f.name === NO_CALLS_FEATURE_NAME)) return 0 // gerencial: não liga
  if (features.some(f => f && f.name === UNLIMITED_CALLS_FEATURE_NAME)) return null // ilimitado

  return null
}

export function getSubscriptionContext () {
  return loopback.get('/subscriptions').then(response => {
    const subscriptions = response && Array.isArray(response.items) ? response.items : []
    const activeSubscriptions = subscriptions.filter(subscription => subscription.status === ACTIVE_STATUS)
    const dataByUserId = {}
    const seats = []
    let billingDay = null
    let netValue = null
    activeSubscriptions.forEach(subscription => {
      if (billingDay === null && typeof subscription.dueDay === 'number') {
        billingDay = subscription.dueDay
      }
      if (typeof subscription.netValue === 'number') {
        netValue = (netValue === null ? 0 : netValue) + subscription.netValue
      }
      const items = Array.isArray(subscription.items) ? subscription.items : []
      items.forEach(item => {
        const plan = item.plan && item.plan.title !== undefined ? item.plan.title : null
        // O código, além do título: é ele que resolve a cor do plano e as comparações
        // da tela de Usuários. Título é rótulo, não chave.
        const planCode = item.planName !== undefined ? item.planName : null
        const value = item.value !== undefined ? item.value : null
        const limit = getVoiceThreshold(item)
        const itemSeats = Array.isArray(item.seats) ? item.seats : []
        itemSeats.forEach(seat => {
          const userId = seat.userId === undefined ? null : seat.userId
          const removalActivateAt = seat.removalActivateAt === undefined ? null : seat.removalActivateAt
          const pendingPlanCode = seat.pendingPlanName === undefined ? null : seat.pendingPlanName
          const planChangeActivateAt = seat.planChangeActivateAt === undefined ? null : seat.planChangeActivateAt
          seats.push({ seatId: seat.publicId, userId, planCode, plan, value, limit, removalActivateAt, pendingPlanCode, planChangeActivateAt })
          if (userId !== null) {
            dataByUserId[userId] = { plan, planCode, value, limit }
          }
        })
      })
    })
    return { dataByUserId, seats, billingDay, netValue }
  })
}

// Simulação da primeira cobrança, via pbxapi — NÃO direto no billing. A conta é
// resolvida lá pelo token, e não viaja daqui: a chave do billing é injetada em
// build-time no bundle, então um endpoint que aceitasse `accountId` do cliente
// deixaria qualquer usuário logado consultar conta alheia.
//
// `quantitiesByPlanCode` é indexado pelo CÓDIGO do plano como ele existe no billing
// (`plan.name` e `price.resourceName`), sempre minúsculo: a busca lá é exata, e em
// maiúsculas o preço não é encontrado, o billing engole o erro e devolve base zerada —
// a simulação da tela aparecia como R$ 0,00.
export async function calculateProrata (billingDay, quantitiesByPlanCode) {
  const users = []
  Object.entries(quantitiesByPlanCode || {}).forEach(([planCode, quantity]) => {
    if (quantity > 0) {
      users.push({ name: planCode, quantity })
    }
  })

  // O cliente loopback já devolve o body (interceptor em loopback.js) — sem `.data`.
  return loopback.get('/users/proration-calculation', {
    params: {
      billingDay: billingDay,
      users: JSON.stringify(users)
    }
  })
}

export function occupySeat (email, seatId) {
  return loopback.post('/users/occupy-seat', { email, seatId })
}

// `items`: [{ planName, quantity }] — vários planos na mesma compra, uma cobrança só.
export function previewSeatPurchase (items) {
  return loopback.post('/subscriptions/seat-purchase/preview', { items })
}

export function purchaseSeats (items, billingType) {
  return loopback.post('/subscriptions/seat-purchase', { items, billingType })
}

// A compra de licenças aguardando pagamento (no máximo uma), ou null.
export function getPendingSeatPurchase () {
  return loopback.get('/subscriptions/seat-purchase/pending').then(result => result.pending)
}

export function cancelSeatPurchase (publicId) {
  return loopback.post(`/subscriptions/seat-purchase/${encodeURIComponent(publicId)}/cancel`)
}

export function cancelSeatRemoval (seatId) {
  return loopback.patch(`/subscriptions/seats/${encodeURIComponent(seatId)}/cancel-removal`)
}



// WEBPACK FOOTER //
// ./src/services/subscription.js